import styled from 'styled-components'

const LoginLogo = styled.img `
    width: 240px;
    margin-bottom: 60px;
`

export default LoginLogo;